import { documentReady } from "@sazka/utils/document-ready";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import { useTicketsSlider } from "../composables/use-tickets-slider";
import { useKeenSliderConfig } from "../composables/use-keen-slider-config";

documentReady(async () => {
    const container = document.getElementById("promo-popular-slider");
    const buttonLeft = document.getElementById("promo-popular-slider-prev");
    const buttonRight = document.getElementById("promo-popular-slider-next");

    onViewportEnter(container, 0).then(() => {
        const sliderConfig = useKeenSliderConfig();

        useTicketsSlider({ container, buttonLeft, buttonRight, sliderConfig, updateOnLogout: true });
    });
});
